import { render, staticRenderFns } from "./EprescribePage.vue?vue&type=template&id=662b37ab"
import script from "./EprescribePage.vue?vue&type=script&lang=js"
export * from "./EprescribePage.vue?vue&type=script&lang=js"
import style0 from "./EprescribePage.vue?vue&type=style&index=0&id=662b37ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports